import React from 'react';
import { useNavigate } from 'react-router-dom';
import ServiceForm from '../../components/Services/ServiceForm';
import Toast from '../../components/Common/Toast';
import { useState } from 'react';

const CreateService = () => {
  const navigate = useNavigate();
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  const handleSuccess = () => {
    setToast({
      isOpen: true,
      message: 'Servicio creado exitosamente',
      type: 'success'
    });
    setTimeout(() => {
      navigate('/services');
    }, 1500);
  };

  const handleCancel = () => {
    navigate('/services');
  };

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Nuevo Servicio</h1>
          <p className="text-gray-600 mt-1">Complete el formulario para crear un nuevo servicio</p>
        </div>

        {/* Formulario */}
        <ServiceForm
          isOpen={true}
          onClose={handleCancel}
          service={null}
          onSuccess={handleSuccess}
          isPageMode={true}
        />

        {/* Toast de notificaciones */}
        <Toast
          isOpen={toast.isOpen}
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ ...toast, isOpen: false })}
        />
      </div>
    </div>
  );
};

export default CreateService;






